<div
  [ngClass]="hero() ? 'lg:py-6' : 'bg-white drop-shadow-md'"
  class="header"
>
  <div class="relative grid lg:grid-cols-10 items-center">
    <div
      routerLink="/"
      class="btn justify-self-start col-span-1"
    >
      <ticketing-combined-logo
        class="block h-10 md:h-12"
        [appearance]="hero() ? 'light' : 'dark'"
      />
    </div>
    <div
      class="hidden lg:flex place-content-center uppercase col-span-8"
      [ngClass]="hero() ? 'text-white' : 'text-platform'"
    >
      @for (item of navItems(); track item.name) {
        <div
          routerLink="{{ item.path }}"
          class="btn navlink"
          routerLinkActive="active"
        >
          {{ item.name }}
        </div>
      }
    </div>
    <div class="hidden lg:block justify-self-end col-span-1">
      @if (isAuthenticated()) {
        <div class="px-1">
          <ticketing-initials-icon
            routerLink="/profile"
            [user]="user()"
            [appearance]="hero() ? 'light' : 'dark'"
          />
        </div>
      } @else {
        <ticketing-button
          routerLink="/profile"
          [appearance]="hero() ? 'white' : 'primary'"
          >Anmelden</ticketing-button
        >
      }
    </div>
  </div>
</div>
